import api from "./base-api"
import {buildStateCreateParams} from "./stateCopyParams"


const dsStateApiV2 = api.injectEndpoints({
    endpoints: (build) => ({
        getStateV2DS: build.query({
            query: (data) => {
                return `v2/ds/states/${data.deviceId}/${data.stateId}`
            },
            providesTags: ['UserStates']
        }),
        getStatesByFacebookIdV2DS: build.query({
            query: (facebookId = "") => `v2/ds/states/facebook/${facebookId}`
        }),
        createStateV2DS: build.mutation({
            query: (data) => {
                const {userId, vendorId, game, isDirectCopy, sourceUserId, sourceVendorId, comment, zendeskTicketId, ...body} = data
                const params = buildStateCreateParams({vendorId, isDirectCopy, sourceUserId, sourceVendorId, comment, zendeskTicketId})

                return {
                    url: `v2/ds/states/${game}/${userId}?${params.toString()}`,
                    method: "POST",
                    body: body.body
                }
            },
            invalidatesTags: ['UserStates']
        }),
        clearData: build.mutation({
            query: () => null,
            onQueryStarted: (arg, {dispatch, queryFulfilled}) => {
                dispatch(clearData())
                queryFulfilled(undefined, {data: null})
            },
        }),
        checkDSExist: build.mutation({
            query: (body = {}) => ({
                url: `v2/ds/states/exist`,
                method: "POST",
                body: body
            }),
        }),
        advancedSearchDS: build.mutation({
            query: (body = {}) => ({
                url: `v2/ds/states/advancedSearch`,
                method: "POST",
                body: body
            }),
        }),
    }),
    overrideExisting: false
})

export const {
    useGetStateV2DSQuery,
    useGetStatesByFacebookIdV2DSQuery,
    useCreateStateV2DSMutation,
    clearData,
    useCheckDSExistMutation,
    useAdvancedSearchDSMutation
} = dsStateApiV2
